window.okeReviewsWidgetOnInit = function () {
    configureWidgetAggregate();
    configureStarRatingClick();

    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const observerConfig = {
            childList: true
        };
        const observer = new MutationObserver(moveStarRatings);
        observer.observe(reviewMain, observerConfig);
        moveStarRatings();
    }
};

// Move Rating Value next to Rating Count and Trim Rating Count
function configureWidgetAggregate() {
    let ratingValue = document.querySelector('.okeReviews .okeReviews-reviewsAggregate-summary-rating-value');
    let productInfoReviewsCount = document.querySelector('[data-oke-reviews-product-listing-rating] .okeReviews-reviewsSummary-ratingCount');
    let reviewsCount = document.querySelector('.okeReviews .okeReviews-reviewsAggregate-summary-total');

    if (ratingValue && productInfoReviewsCount) {
        productInfoReviewsCount.insertAdjacentElement('beforebegin', ratingValue.cloneNode(true));
    }

    if (reviewsCount) {
        let regexResult = reviewsCount.innerHTML.match(/(?:.*)(\b[0-9]+\b)(?:\sde\s)?(.*)/); 
        if (regexResult) {
            reviewsCount.innerHTML = `${regexResult[1]} ${regexResult[2]}`;
        }
        if (ratingValue) {
            reviewsCount.insertAdjacentElement('beforebegin', ratingValue);
            ratingValue.insertAdjacentElement('beforeend', reviewsCount);
        }
    }
}

// Allow Clicking Star Rating to open Reviews Tab
function configureStarRatingClick() {
    const reviewSummaryElement = document.querySelector('.js-okeReviews-reviewsSummary');
    const reviewTabElement = document.querySelector('#okeReviews-collapse-trigger');
    if (reviewTabElement && reviewSummaryElement) {
        reviewSummaryElement.addEventListener('click', function () {
            if (reviewTabElement.getAttribute('aria-expanded') === 'false') {
                reviewTabElement.click();
            }
        });
    }
}

function moveStarRatings() {
    const reviewStarRatings = document.querySelectorAll('.okeReviews-review .okeReviews-review-starRating');
    const reviewerDetails = document.querySelectorAll('.okeReviews-review .okeReviews-review-reviewer-profile-details-inner');

    if (reviewStarRatings.length > 0 && reviewerDetails.length > 0) {
        for (let i = 0; i < reviewerDetails.length; i++) {
            reviewerDetails[i].insertAdjacentElement('afterend', reviewStarRatings[i]);
        }
    }
}
